const Messages = Object.freeze({
  ALL: 'All',
  SELECT_ALL: 'Select All',
  CLEAR_ALL: 'Clear All',
  CLOSE: 'Close',
});

export default Messages;
